import { OneDriveFolder } from "models/OneDriveFolder";
import { OneDriveSyncAgendaItem } from "models/OneDriveSyncAgendaItem";
import { OneDriveViewModel } from "models/OneDriveViewModel";
import { SyncActionsType, SyncActionType } from "models/SyncActionsType";
import { createContext } from "react";

export interface OneDriveSyncContextProps {
  isLoading: boolean;
  oneDriveViewModel: OneDriveViewModel | undefined;
  folder: OneDriveFolder | undefined;
  agendaItems: OneDriveSyncAgendaItem[] | undefined;
  refetch: () => void;
  isEnabledSync: boolean;
  isSubmitting: boolean;
  setIsSubmitting: (state: boolean) => void;
  isAdvancedMode: boolean;
  setIsAdvancedMode: (state: boolean) => void;
  onExecuteSync: () => void;
  selectDocumentId: number;
  setSelectDocumentId: (id: number) => void;
  agendaItemActions: SyncActionsType;
  setAgendaItemActions: (state: SyncActionsType) => void;
  setAgendaItemAction: (id: number, action: SyncActionType) => void;
  documentActions: SyncActionsType;
  setDocumentActions: (state: SyncActionsType) => void;
  setDocumentAction: (id: number, action: SyncActionType) => void;
}

export const OneDriveSyncContext = createContext({} as OneDriveSyncContextProps);
